import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import Image from '../Image';

const Picture = (props) => {
    return <Link onClick={props.onClick} title={props.label}><div className="grid-elem">
        <div className="logo">
            <Image url={props.url.preview} />
        </div>
        <div className="label">{props.label}</div>
    </div></Link>;
}

Picture.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.object,
    onClick: PropTypes.func
}

export default Picture;